import { ApolloProvider } from "@apollo/client"
import { QueryClientProvider } from "@tanstack/react-query"
import { SnackbarCloseButton } from "components/common"
import { AppHooks, AppTheme } from "containers"
import { AlertProvider } from "hooks"
import { SnackbarProvider } from "notistack"
import { PropsWithChildren } from "react"
import { Provider } from "react-redux"
import { persistor, store } from "reducers/store"
import { PersistGate } from "redux-persist/integration/react"
import { apolloClient, queryClient } from "services"

const AppProvider = ({ children }: PropsWithChildren) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SnackbarProvider
          action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
          anchorOrigin={{ horizontal: "right", vertical: "top" }}
          autoHideDuration={5000}
          preventDuplicate
          variant="success"
        >
          <ApolloProvider client={apolloClient}>
            <QueryClientProvider client={queryClient}>
              <AppHooks>
                <AppTheme>
                  <AlertProvider>{children}</AlertProvider>
                </AppTheme>
              </AppHooks>
            </QueryClientProvider>
          </ApolloProvider>
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  )
}

export default AppProvider
